import * as React from "react";
import { ITriggerManualJob } from "../../../redux/types/ITriggerManualJob";
import { CONTRIBUTORS_MASS_UPDATE_JOB_TYPE, DRAFT_AGREEMENT_SUBMISSION_JOB_TYPE, PACKAGE_ID, PACKAGE_SHARE_SET, PACKAGE_TERRITORY, TRANSFER_RELATIONSHIP_TITLE, UPDATE_AGREEMENT_ASSIGNEES } from "../../Consts";
import ActionButton from "../../../repertoire/components/actionButton/ActionButton";
import {
    triggerManualJob,
} from "../../../redux/thunks/HomeThunks";
import DropdownDataInput from "../../../repertoire/components/dropdownDataInput/DropdownDataInput";
import { SizedCheckboxDataInput } from "../../../repertoire/components/checkboxDataInput/CheckboxDataInput";
import DataGridTable from "../../../repertoire/components/dataGridTable/DataGridTable";
import { IIPsSearchQuery } from "../../../repertoire/types/IIPsSearchQuery";
import { ADD_NEW_ACTION, CMU_CONTRIBUTORS_KEY, CONTRIBUTORS_KEY, REMOVE_ACTION, SEARCH_VIEW, SEARCH_VIEW_CMU_JOB_IP, TABLE_ACTIONS_INSTANCE_KEY } from "../../../repertoire/Consts";
import { IRepertoireStateKeys } from "../../../repertoire/types/IRepertoireStateKeys";
import { SET_TYPE_GROUP_LOOKUP, SET_TYPE_LOOKUP } from "../../../lookup/Consts";
import { getLookupValues } from "../../../lookup/services/LookupHelpers";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { SearchRequests } from "../../../repertoire/services/SearchRequests";
import { IInterestedParty } from "../../../repertoire/types/IInterestedParty";
import { SizedRadiobuttonDataInput } from "../../../repertoire/components/radioButtonDataInput/RadiobuttonDataInput";



export interface IContributorsMassUpdateParametersProps {
    createNewJob: () => any;
    triggerManualJob: typeof triggerManualJob;
    updateManualJobParams?: (params: any) => void;
    searchIPs?: (query: IIPsSearchQuery) => void;
    showModal?: (
        modalContent: string,
        modalComponentInstance: string,
        modalProps: any,
        displayModalCloseButton: boolean,
        title: string,
        modalMessage?: string,
        isReadOnly?: boolean,
        key?: string,
        index?: number
    ) => void;
    searchViewData?: any;
    searchResultsTableData?: any;
    cmuContributors?: any;
    updateCMUContributors?: (contributors: any, modalIndex?: number) => void;
    packageResults?: any;
    getIPDetails?: (ipBaseNumber: string, accountNumber: string, lookups: any) => void;
    ipdetails?: any[];
    lookupValues?: ILookupDictionary;
    customerTerritory?: string;
    scheduledJobSet?: (value: boolean) => void;
    onError?: (errorMessage: string) => void;
}


const ContributorsMassUpdateParameters = (props: IContributorsMassUpdateParametersProps) => {
    const [packageId, setPackageId] = React.useState<number>(0);
    const [transferRelationship, setTransferRelationship] = React.useState<boolean>(true);
    const [updateAgreementAssignees, setUpdateAgreementAssignees] = React.useState<boolean>(false);
    const [territory, setTerritory] = React.useState<string>(props.customerTerritory);
    const [shareSet, setShareSet] = React.useState<string>('Repertoire');
    const [contributors, setContributors] = React.useState<any[]>();
    const [ipInfo, setIpInfo] = React.useState<{ ipBaseNumber: string, ipiNumber: string }[]>([{ ipBaseNumber: '', ipiNumber: '' }]);
    const [generalError, setGeneralError] = React.useState<string[]>([]);
    const [ipdetailsState, setIpdetails] = React.useState<any>();
    const [ipArray ,setIpArray] = React.useState<any[]>([]);
    const ipArrayRef = React.useRef<any[]>([]);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [sharePercentage, setSharePercentage] = React.useState<string>('RS');

    let newArray: any[] = [];
    React.useEffect(() => {
        if (props.ipdetails) {            
            setIpdetails(prev => {
             newArray = prev ? [...prev, props.ipdetails] : [props.ipdetails];
            return newArray;
            });
            ipArrayRef.current = [...ipArrayRef.current, props.ipdetails];
            setIpArray([...ipArrayRef.current]);
        }
    }, [props.ipdetails]);

    const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    async function fetchContributorDetails() {
        ipArrayRef.current = [];
        setIpArray([]);

        for (let i = 0; i < ipInfo.length; i++) {
            const ipBaseNumber = ipInfo[i]?.ipBaseNumber;
            const accountNumber = contributors?.[i]?.accountNumber?.value;

            const res: IInterestedParty = ipBaseNumber
                ? await SearchRequests.getIP(ipBaseNumber)
                : await SearchRequests.getIP(undefined, accountNumber);

            ipArrayRef.current = [...ipArrayRef.current, res];
            setIpArray([...ipArrayRef.current]);

            if (i < ipInfo.length - 1) {
                await delay(1000);
            }
        }
    }
    React.useEffect(() => {
        if (props.cmuContributors && props.cmuContributors.length) {
            const mappedContributors = props.cmuContributors.map((contributor: any) => ({
                accountNumber: { value: contributor.accountNumber, inputType: "readonly" },
                ipiNumber: { value: contributor.ipiNumber, inputType: "text" },
                name: { value: contributor.ipName, inputType: "textReadonlyInRepertoire" },
                mechPercentage: { value: contributor.mechPercentage, inputType: "integerPercentage" },
                perfPercentage: { value: contributor.perfPercentage, inputType: "integerPercentage" },
                mechanicalShareToDisplay: { value: contributor.mechanicalShareToDisplay, inputType: "integerPercentage" },
                performingShareToDisplay: { value: contributor.performingShareToDisplay, inputType: "integerPercentage" }
            }));
            setContributors(mappedContributors);
            setIpInfo(props.cmuContributors.map(c => ({ ipBaseNumber: c.ipBaseNumber, ipiNumber: c.ipiNumber })));
        }
    }, [props.cmuContributors]);

    React.useEffect(() => {
        let contributors = [{
            accountNumber: null,
            ipiNumber: '',
            ipName: '',
            mechPercentage: 100,
            perfPercentage: 100,
            mechanicalShareToDisplay: 100,
            performingShareToDisplay: 100,
        }, {
            accountNumber: null,
            ipiNumber: '',
            ipName: '',
            mechPercentage: 100,
            perfPercentage: 100,
            mechanicalShareToDisplay: 100,
            performingShareToDisplay: 100,
        }]
        props.updateCMUContributors(contributors)
    }, []);

    const validateFields = () => {
        let errorList = [];
        const sumPerfPercent = contributors =>
            contributors.reduce((sum, x) => {
                const percent = parseFloat((x.perfPercentage.value || '0').toString().trim());
                return sum + (isNaN(percent) ? 0 : percent);

            }, 0);
        const fromIPPerf = sumPerfPercent([contributors[0]]);
        const toIPPerf = sumPerfPercent(contributors.slice(1));
        const sumMechPercent = contributorsArray => contributorsArray.reduce((sum, x) => {
            const percent = parseFloat((x.mechPercentage.value || '0').toString().trim());
            return sum + (isNaN(percent) ? 0 : percent);
        }, 0);
        const fromIPMech = sumMechPercent([contributors[0]]);
        const toIPMech = sumMechPercent(contributors.slice(1));
        if (fromIPPerf !== toIPPerf) {
            errorList.push('Total "To IP" performance shares must equal total "From IP" performance shares.');
        }
        if (fromIPMech !== toIPMech) {
            errorList.push('Total "To IP" mechanical shares must equal total "From IP" mechanical shares.');
        }
        setGeneralError(errorList);
        return (errorList.length === 0);
    };

    const onClickSave = async () => {
        const { triggerManualJob, createNewJob, updateManualJobParams, showModal, ipdetails, getIPDetails, lookupValues,scheduledJobSet,onError } = props;
        try {
            if (validateFields()) {
                setIsSubmitting(true);
                let territoryCode = getLookupValues(SET_TYPE_GROUP_LOOKUP, props.lookupValues).filter(x => x.typeID > 0).find(x => x.code === territory);
                let sharesetcode = getLookupValues(SET_TYPE_LOOKUP, props.lookupValues).filter(x => x.typeID < 0).find(x => x.code === shareSet.toLocaleLowerCase());
                await fetchContributorDetails();
                if (ipArrayRef.current.length !== contributors.length) {
                    while (ipArrayRef.current.length !== contributors.length) {
                        await delay(500);
                    }
                }
                if (ipArrayRef.current && ipArrayRef.current.length === contributors.length) {
                    let socipid = ipArrayRef.current[0]?.socIP?.socIPID;
                    let targetAccountNumberList = contributors.slice(1).map(c => c.accountNumber?.value);
                    let targetIPBaseNumberList = ipArrayRef.current.slice(1).map(c => c.ipBaseNumber);
                    let targetIPINumberList = contributors.slice(1).map(c => c.ipiNumber?.value);
                    let targetSocIPIDList = ipArrayRef.current.slice(1).map(item => item?.socIP?.socIPID ?? null);
                    let toIPMechShares = contributors.slice(1).map(c => c?.mechPercentage?.value);
                    let toIPPerfShares = contributors.slice(1).map(c => c?.perfPercentage?.value);
                    const manualJobParameters: ITriggerManualJob = {
                        jobType: CONTRIBUTORS_MASS_UPDATE_JOB_TYPE,
                        jobParameters: JSON.stringify({
                            AccountNumberToChange: contributors[0].accountNumber.value,
                            IPINumber: contributors[0].ipiNumber.value ? contributors[0].ipiNumber.value : null,
                            IPBaseNumber: ipArrayRef.current[0]?.ipBaseNumber ?? null,
                            IRSocIPID: socipid ? socipid : null,
                            PackageID: packageId ? packageId : null,
                            TransferRelationship: transferRelationship,
                            updateAgreementAssignees: updateAgreementAssignees,
                            isShareTransferUpdate: true,
                            Territory: territory ? territoryCode.typeID : null,
                            Shareset: shareSet ? sharesetcode.typeID : null,
                            FromIPPerfShare: contributors[0].perfPercentage.value,
                            FromIPMechShare: contributors[0].mechPercentage.value,
                            TargetContributors: targetIPBaseNumberList.map((_, i) => ({
                                TargetAccountNumber: targetAccountNumberList[i],
                                TargetIPINumber: targetIPINumberList[i],
                                TargetSocIPID: targetSocIPIDList[i] ?? null,
                                TargetIPBaseNumber: targetIPBaseNumberList[i],
                                ToIPPerfShare: toIPPerfShares[i],
                                ToIPMechShare: toIPMechShares[i]
                            })),
                            isRelativeShareTransfer: sharePercentage === "RS"
                        }),
                    };
                    createNewJob();
                    triggerManualJob(manualJobParameters);
                    scheduledJobSet(true);
                    if (updateManualJobParams) {
                        updateManualJobParams('');
                    }
                }
            }
        } catch (error) {
            onError(error.toString());
        } finally {
            setIsSubmitting(false);
        }

    };
    const handleChangePackageId = (value) => {
        setPackageId(value);
    }
    const handleChangePackageTerritory = (value) => {
        setTerritory(value);
    }
    const handleChangePackageShareSet = (value) => {
        setShareSet(value);
    }
    const handleChangeTransferRelationship = (value) => {
        setTransferRelationship(value);
    }

    const handleChangeUpdateAgreementAssignees = (value) => {
        setUpdateAgreementAssignees(value);
    } 
   let gridDataTable = { fields: (props.searchResultsTableData.fields.filter((field: any) => field.componentInstance === CONTRIBUTORS_KEY)).filter((field: any) => field.name != "update_action") };
    gridDataTable.fields.push({
        componentInstance: TABLE_ACTIONS_INSTANCE_KEY,
        name: ADD_NEW_ACTION,
        data: "Add New",
        inputType: "addAction",
        order: 0
    }, {
        componentInstance: CONTRIBUTORS_KEY,
        name: REMOVE_ACTION,
        data: "Remove",
        fieldType: "remove_action",
        order: 0
    });
    let highestOrder = Math.max(...gridDataTable.fields.map(item => item.order));
    let updatedGridData = gridDataTable.fields.map(item =>
        item.fieldType === "remove_action" ? { ...item, order: highestOrder + 1 } : item
    );
    const changeData = (value: any[], name: IRepertoireStateKeys) => {
        const { updateCMUContributors } = props;
        let updatedContributors = [];
        if (value && value.length > 0) {
            updatedContributors = value.map((contributor: any) => ({
                accountNumber: contributor.accountNumber.value,
                ipiNumber: contributor.ipiNumber.value,
                ipName: contributor.name ? contributor.name.value : contributor.ipName.value,
                mechPercentage: contributor.mechPercentage.value,
                perfPercentage: contributor.perfPercentage.value,
                mechanicalShareToDisplay: contributor.mechanicalShareToDisplay.value,
                performingShareToDisplay: contributor.performingShareToDisplay.value,
                ipBaseNumber: ipInfo.find(i => i.ipiNumber === contributor.ipiNumber.value)?.ipBaseNumber ?? ''
            }));
        }

        updateCMUContributors(updatedContributors);
    }
    const dismissAlert = () => {
        setGeneralError([]);
    };
    const handleSharePercentageChange = (selection: string) => {
        setSharePercentage(selection);
    }; 

    return (
        <>
            {generalError && generalError.length > 0 && (<div className="alert alert-danger alert-dismissible">
                {generalError && <button type="button" className="close" aria-label="Close" onClick={dismissAlert}>
                    <span aria-hidden="true">&times;</span>
                </button>}
                {generalError.map((error, index) => (
                    <span key={index}>
                        {error}
                        <br />
                    </span>
                ))}
            </div>)}
            <div className="row" style={{ padding: "25px" }}>
                <DataGridTable
                    tableContents={contributors}
                    dataGridTableData={{fields:updatedGridData}}
                    stateKey={CONTRIBUTORS_KEY}
                    componentInstance={CONTRIBUTORS_KEY}
                    showRowNumber={true}
                    isReadOnly={false}
                    tableActions={[{ name: ADD_NEW_ACTION }, { name: REMOVE_ACTION }]}
                    showDropdownsAsCodes={false}
                    showModal={props.showModal}
                    showRowName={true}
                    changeData={changeData.bind(this)}
                />
            </div>
            <div className="row">
                <SizedRadiobuttonDataInput
                    selectedValue={sharePercentage}
                    onSelectionChange={handleSharePercentageChange}
                    radioName=""
                    title={null}
                    options={[
                        { desc: "Relative Share Percentage", code: "RS" },
                        { desc: "Absolute Share Percentage", code: "AS" }
                    ]}
                />
            </div>
            <div className="row">
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <DropdownDataInput
                        label={PACKAGE_ID}
                        fieldName={PACKAGE_ID}
                        changeData={handleChangePackageId.bind(this)}
                        value={packageId}
                        options={
                            [
                                { code: "", description: "" },
                                ...(props.packageResults
                                    ? props.packageResults
                                        .filter((pkg: any) => pkg.entityType === 'Works')
                                        .map((packageResult: any) => ({
                                            code: packageResult.id,
                                            description:  `${packageResult.id}`,
                                        }))
                                    : []),
                            ]
                        }
                        allowNull={false}
                        isHidden={false}
                    />
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <DropdownDataInput
                        label={PACKAGE_TERRITORY}
                        fieldName={PACKAGE_TERRITORY}
                        changeData={handleChangePackageTerritory.bind(this)}
                        value={territory}
                        options={getLookupValues(SET_TYPE_GROUP_LOOKUP, props.lookupValues).filter(x => x.typeID > 0)}
                        allowNull={false}
                        isHidden={false}
                    />
                </div>
            </div>
            <div className="row">
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <DropdownDataInput
                        label={PACKAGE_SHARE_SET}
                        fieldName={"packageShareSet"}
                        changeData={handleChangePackageShareSet.bind(this)}
                        value={shareSet}
                        options={getLookupValues(SET_TYPE_LOOKUP, props.lookupValues).filter(x => x.typeID < 0)}
                        allowNull={false}
                        isHidden={false}
                    />
                </div>
                <div className="col-md-3 col-sm-3 col-xs-6 paddingVerticalExtraLarge">
                    <SizedCheckboxDataInput
                        label={TRANSFER_RELATIONSHIP_TITLE}
                        fieldName={TRANSFER_RELATIONSHIP_TITLE}
                        value={transferRelationship}
                        changeData={handleChangeTransferRelationship.bind(this)}
                    />
                </div>

                <div className="col-md-3 col-sm-3 col-xs-6 paddingVerticalExtraLarge">
                    <SizedCheckboxDataInput
                        label={UPDATE_AGREEMENT_ASSIGNEES}
                        fieldName={UPDATE_AGREEMENT_ASSIGNEES}
                        value={updateAgreementAssignees}
                        changeData={handleChangeUpdateAgreementAssignees.bind(this)}
                    />
                </div>
            </div>
            <div className="row">
                <div
                    className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                    <ActionButton buttonText={"Cancel"} buttonAction={props.createNewJob} className={"button btn-defaultSecondary"} />
                </div>
                <div
                    className="form-group col-lg-4 col-lg-push-4 col-md-4 col-md-push-4 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0">
                    <ActionButton
                        buttonText={"Start Job"}
                        buttonAction={() => onClickSave()}
                        disabled={isSubmitting}
                    />
                </div>
            </div>
        </>
    );
}

export default ContributorsMassUpdateParameters;

